var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tabs),function(tab){return _c('UiTab',{key:tab.key,attrs:{"tag":_vm.tag,"tab":tab},on:{"click":function($event){_vm.tabСlick($event)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }